import { InvoiceTaxationNature } from '@/core/domain/invoice/invoices/invoices.enums';

export const taxationNatureOptions = [
  {
    value: InvoiceTaxationNature.SIMPLES_NACIONAL,
    label: 'Simples Nacional',
  },
  {
    value: InvoiceTaxationNature.FIXO,
    label: 'Fixo',
  },
  {
    value: InvoiceTaxationNature.DEPOSITO_EM_JUIZO,
    label: 'Depósito de Juízo',
  },
  {
    value: InvoiceTaxationNature.EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL,
    label: 'Exigibilidade suspensa por decisão Judicial',
  },
  {
    value:
      InvoiceTaxationNature.EXIGIBILIDADE_SUSPENSA_PROCEDIMENTO_ADMINISTRATIVO,
    label: 'Exigibilidade suspensa por procedimento administrativo',
  },
  {
    value: InvoiceTaxationNature.ISENCAO_PARCIAL,
    label: 'Isenção parcial',
  },
];
